import { useEffect, useState } from "react";
import { AdminLayout } from "../../components/Layouts";
import { api, readUser, fmt } from "../../lib/api";

export default function AdminLedger() {
  const user = readUser();
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState("All");
  useEffect(() => { api.get("/admin/transactions").then((r) => setRows(r.data)).catch(() => {}); }, []);
  const types = ["All", "Mining Reward", "Deposit", "Package Activation", "Daily Production", "Referral", "Withdrawal", "Withdrawal Fee", "Adjustment"];
  const filtered = rows.filter((r) => filter === "All" ? true : (filter === "Referral" ? r.type.startsWith("Referral") : r.type.includes(filter)));
  return (
    <AdminLayout user={user} active="İşlem Defteri">
      <section className="admin-panel">
        <div className="admin-panel-title">
          <div><span className="eyebrow">LEDGER</span><h2>Tüm Hareketler ({rows.length})</h2></div>
          <div className="filter-pills">
            {types.map((t) => <button key={t} className={filter === t ? "pill active" : "pill"} onClick={() => setFilter(t)} data-testid={`admin-tx-filter-${t.toLowerCase().replace(/[ ]/g, "-")}`}>{t}</button>)}
          </div>
        </div>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Tarih</th><th>Kullanıcı</th><th>Tür</th><th>Tutar</th><th>Önce</th><th>Sonra</th><th>Referans</th><th>Durum</th></tr></thead>
            <tbody>
              {filtered.map((t, i) => (
                <tr key={i} data-testid={`admin-tx-row-${i}`}>
                  <td>{new Date(t.date).toLocaleString("tr-TR")}</td>
                  <td className="hash">{(t.user_id || "").slice(0, 10)}…</td>
                  <td>{t.type}</td>
                  <td className={t.amount < 0 ? "neg" : "pos"}>${fmt(t.amount, t.type === "Mining Reward" ? 3 : 2)}</td>
                  <td>${fmt(t.balance_before, t.type === "Mining Reward" ? 3 : 2)}</td>
                  <td>${fmt(t.balance_after, t.type === "Mining Reward" ? 3 : 2)}</td>
                  <td className="hash">{(t.reference || "").slice(0, 14)}</td>
                  <td><span className={`status ${t.status.toLowerCase()}`}>{t.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
          {!filtered.length && <div className="table-empty">Bu filtre için kayıt yok.</div>}
        </div>
      </section>
    </AdminLayout>
  );
}
